export interface IAppConfig {
  apiUrl: string;
  bitrixUrl: string;
}

export const AppConfig = Object.freeze(getConfig(process.env));

function getConfig(env: any): IAppConfig {

  const config: IAppConfig = {
    apiUrl: parseInt(env['VUE_APP_USE_MOCK_SERVER'], 10) ? env.VUE_APP_MOCK_API : env.VUE_APP_API,
    bitrixUrl: env.VUE_APP_REGISTRATION_ON_BITRIX,
  };

  return config;
}
